import clsx from 'clsx';
import { FC, MouseEventHandler } from 'react';
import { useColorMap, useIconMap } from 'molecules/VariantList/hooks';
import { MultiColor } from 'molecules/VariantList/types';
import { IVariantLinkProps } from './types';
import styles from './styles.module.css';

const ColorCircle: FC<{
  color: MultiColor;
  idx: number;
  className?: string;
}> = ({ color, idx, className }) => {
  const colorMap = useColorMap();
  const iconMap = useIconMap();
  const hexColor = colorMap[color.label?.toLowerCase() || ''];
  const icon = iconMap[color.label?.toLowerCase() || ''];

  return (
    <span
      title={color.value}
      key={color.label}
      style={{ background: hexColor || `url(${icon})` }}
      className={clsx(className, styles[`color${idx + 1}`])}
    />
  );
};

export const VariantItem: FC<
  Omit<IVariantLinkProps, 'href' | 'title'> & {
    onClick?: MouseEventHandler<HTMLDivElement>;
    className?: string;
  }
> = ({ colors, isActive, onClick, className }) => {
  return (
    <div
      className={clsx(
        styles.Variant,
        className,
        styles[`isType${colors?.length}`],
        {
          [styles.isActive]: isActive && styles.isActive,
        },
      )}
      onClick={onClick}
    >
      {colors?.map((color, idx) => (
        <ColorCircle key={color.value} color={color} idx={idx} />
      ))}
    </div>
  );
};
